import React from "react";
import { useState, useEffect } from "react";
import Calendar from 'react-calendar';

const easternTimeZone = 'America/New_York';
const easternDateFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: easternTimeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
});
const easternTimeFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: easternTimeZone,
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
});

const getEasternDateKey = (date) => {
    const parts = easternDateFormatter.formatToParts(date);
    const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
    return `${values.year}-${values.month}-${values.day}`;
};

const getCalendarDateKey = (date) => {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
};

const TrainingCalendar = ({data}) => {

    const currentDate = new Date();
    const [trainingEvents, setTrainingEvents] = useState(data.map(a => ({id:a.id, name: a.name, date: (new Date(a.date)), duration: a.duration})));
    const [selectedMonth, setSelectedMonth] = useState(currentDate);
    const [modal, setModal] = useState({
        isOpen: false,
        date: currentDate,
        time: "",
        display: ""
    });
    const [viewportClass, setViewportClass] = useState('');

    useEffect(() => {
      const handleResize = () => {
        if (window.innerWidth <= 670) {
          setViewportClass('small-viewport');
        } else {
          setViewportClass('');
        }
      };
  
      handleResize(); // Call initially to set the class on mount
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    const trainingEvent = (date) => {
        let entry = ''
        trainingEvents.forEach((trainingEvent) => {
                    if(getCalendarDateKey(date) === getEasternDateKey(trainingEvent.date)){
            entry = <div className="calendar-tile--content">
                    <p className="course">{trainingEvent.name}</p>
                                        <p className="time">{formatTime(trainingEvent.date, trainingEvent.duration)}</p>
                </div>

            if(viewportClass === 'small-viewport'){
                entry = <div className="calendar-tile--content" onClick={() => onDayClick(trainingEvent)}>
                    <div className="mobile">{calendarIcon}</div>
                </div>
            }
          }
        })

        return entry;
    }

    const formatTime = (date, duration) => {
        const endDate = new Date(date.getTime() + duration * 60 * 60 * 1000);
        return `${easternTimeFormatter.format(date)} - ${easternTimeFormatter.format(endDate)}`;
    }

    const calendarUpdate = (action, activeStartDate) => {
        console.log(action);
        console.log(activeStartDate)
        //logic for getting new events goes here
    }

    const onDayClick = (event) => {
        setModal({
            isOpen:true,
            date: event.date,
            time: formatTime(event.date, event.duration),
            display: event.name
        });
    }

    const rightArrow = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
        <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
    </svg>

    const leftArrow = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
        <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
    </svg>

    const closeIcon = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
    </svg>

    const calendarIcon = <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-calendar4-event" viewBox="0 0 16 16">
        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z"/>
        <path d="M11 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z"/>
    </svg>

    return <>
        {modal.isOpen && <div className="modal-backround" onClick={() => setModal({isOpen:false})}>
            <div className="modal">
                <div className="modalButtons">
                    <button className="closeButton" onClick={() => setModal({isOpen:false})}>{closeIcon}</button>
                </div>                
                <div className="modal-content">
                    <p>{easternDateFormatter.format(modal.date)}</p>
                    <p>{modal.display}</p>
                    <p>{modal.time}</p>                    
                </div>
            </div>        
        </div>}
        <Calendar
            calendarType="gregory"
            maxDetail="month"
            minDetail="month"
            nextLabel={rightArrow}
            prevLabel={leftArrow}
            next2Label={null}
            prev2Label={null}
            onActiveStartDateChange={({ action, activeStartDate}) => calendarUpdate(action, activeStartDate)}
            tileContent={({ date, view }) => view === 'month' ? trainingEvent(date) : null}
            //onClickDay={onDayClick}
        />
    </>
}

export default TrainingCalendar;